import React from 'react';
import { Heading, HeadingHierarchy } from '../../Heading/Heading';
import { HeadingProps } from '../../../../types/HtmlProps';
import { appendClassName } from '../../../../lib/bemUtils/classname';

type AccordionHeadingProps = HeadingProps & {
  hierarchy?: HeadingHierarchy;
  ref?: React.RefObject<HTMLHeadingElement>;
};

export function AccordionHeading({ hierarchy = 3, children, className, ref, ...props }: AccordionHeadingProps) {
  return (
    <Heading
      hierarchy={hierarchy}
      className={`${appendClassName(className, 'accordion__category')} font-bold-15-19`}
      {...props}
      ref={ref}
    >
      {children}
    </Heading>
  );
}
